import type { Iteratee} from "./sort";
import { sortBy } from "./sort";

type TopResult<T> = {
    item: T;
    score: number;
};

const topOccurences = <T extends { _id: string }>(params: {
    items: T[];
    numberOfItems: number;
    groupBy: Iteratee<T, string>;
}): TopResult<T>[] => {
    const { items, numberOfItems, groupBy } = params;
    const count = items.reduce((count, item) => {
        count.set(item._id, {
            item,
            score: (count.get(groupBy(item))?.score ?? 0) + 1,
        });
        return count;
    }, new Map<string, { item: T; score: number }>());

    return Array.from(count.values())
        .sort(sortBy(item => item.score, "DESCENDING"))
        .slice(0, numberOfItems);
};

const topFiveOccurences = <T extends { _id: string }>(params: {
    items: T[];
    groupBy: Iteratee<T, string>;
}): TopResult<T>[] =>
    topOccurences<T>({
        ...params,
        numberOfItems: 5,
    });

const topTenOccurences = <T extends { _id: string }>(params: {
    items: T[];
    groupBy: Iteratee<T, string>;
}): TopResult<T>[] =>
    topOccurences<T>({
        ...params,
        numberOfItems: 10,
    });

export type { TopResult };
export { topOccurences, topFiveOccurences, topTenOccurences };
